import React from 'react';
import { container } from 'tsyringe';
import { PelatihanPresenter } from '../../../../../../data/presenters/PelatihanPresenter';
import 'react-toastify/dist/ReactToastify.css';
import { Pelatihan } from '../../../../../../entities/Pelatihan';
import { SubMenuJenisPelatihan } from '../../../../../../entities/MenuJenisPelatihan';
import { MenuJenisPelatihanPresenter } from '../../../../../../data/presenters/MenuJenisPelatihanPresenter';
import { PengajuanPelatihan } from '../../../../../../entities/PengajuanPelatihan';
import { PengajuanPelatihanPresenter } from '../../../../../../data/presenters/PengajuanPelatihanPresenter';

interface IState {
  isLoading: boolean;
  jumlahPage: number;
  jumlahPagePengajuan: number;
  page: number;
  pagePengajuan: number;
  keyword: string;
  keywordPengajuan: string;
  tahun: string;
  tahunPengajuan: string;
  jenis_pelatihan_id: string;
  jenis_pengajuan_pelatihan_id: string;
  status_publish: string;
  totalPelatihan: number;
  totalPengajuanPelatihan: number;
  pelatihan: Pelatihan[];
  pengajuanPelatihan: PengajuanPelatihan[];
  subMenuJenisPelatihan: SubMenuJenisPelatihan[];
  rows: number;
  rowsPengajuan: number;
}

interface InitialState {
  state: IState;
  getPelatihan: Function;
  getPengajuanPelatihan: Function;
  setPage: Function;
  setPagePengajuan: Function;
  searchPelatihan: Function;
  searchPengajuanPelatihan: Function;
  filterTahun: Function;
  filterTahunPengajuan: Function;
  filterJenisPelatihan: Function;
  filterJenisPengajuanPelatihan: Function;
  filterStatusPublish: Function;
  getSubMenuJenisPelatihan: Function;
}

const initialState = {
  state: {
    isLoading: true,
    jumlahPage: 0,
    jumlahPagePengajuan: 0,
    page: 1,
    pagePengajuan: 1,
    keyword: '',
    keywordPengajuan: '',
    tahun: '',
    tahunPengajuan: '',
    jenis_pelatihan_id: '',
    jenis_pengajuan_pelatihan_id: '',
    status_publish: '',
    totalPelatihan: 1,
    totalPengajuanPelatihan: 1,
    pelatihan: [],
    pengajuanPelatihan: [],
    subMenuJenisPelatihan: [],
    rows: 21,
    rowsPengajuan: 21,
  },
  getPelatihan: () => {},
  getPengajuanPelatihan: () => {},
  searchPelatihan: () => {},
  searchPengajuanPelatihan: () => {},
  setPage: () => {},
  setPagePengajuan: () => {},
  filterTahun: () => {},
  filterTahunPengajuan: () => {},
  filterJenisPelatihan: () => {},
  filterJenisPengajuanPelatihan: () => {},
  filterStatusPublish: () => {},
  getSubMenuJenisPelatihan: () => {},
};
const Context = React.createContext<InitialState>(initialState);
const { Provider: ManajemenPelatihanProvider } = Context;

const Provider: React.FC = ({ children }) => {
  const [state, setState] = React.useState<IState>({
    isLoading: false,
    jumlahPage: 0,
    jumlahPagePengajuan: 0,
    page: 1,
    pagePengajuan: 1,
    keyword: '',
    keywordPengajuan: '',
    tahun: '',
    tahunPengajuan: '',
    jenis_pelatihan_id: '',
    jenis_pengajuan_pelatihan_id: '',
    status_publish: '',
    totalPelatihan: 0,
    totalPengajuanPelatihan: 0,
    pelatihan: [],
    pengajuanPelatihan: [],
    subMenuJenisPelatihan: [],
    rows: 21,
    rowsPengajuan: 21,
  });

  const setLoading = (value: boolean) => {
    setState((prevstate) => ({
      ...prevstate,
      isLoading: value,
    }));
  };

  const setPage = (value: number) => {
    setLoading(true);

    getPelatihan(
      value + 1,
      state.keyword,
      state.tahun,
      state.jenis_pelatihan_id,
      state.status_publish
    );
    setState((prevstate) => ({
      ...prevstate,
      page: value + 1,
    }));
  };

  const setPagePengajuan = (value: number) => {
    setLoading(true);

    getPengajuanPelatihan(
      value + 1,
      state.keywordPengajuan,
      state.tahunPengajuan,
      state.jenis_pengajuan_pelatihan_id
    );
    setState((prevstate) => ({
      ...prevstate,
      pagePengajuan: value + 1,
    }));
  };

  const setJumlahPage = (value: number) => {
    setState((prevstate) => ({
      ...prevstate,
      jumlahPage: value,
    }));
  };

  const setJumlahPagePengajuan = (value: number) => {
    setState((prevstate) => ({
      ...prevstate,
      jumlahPagePengajuan: value,
    }));
  };

  const getPelatihan = async (
    pagee: number,
    keyword: string,
    tahun: string,
    jenis_pelatihan_id: string,
    status_publish: string = ''
  ) => {
    setLoading(true);

    try {
      const pelatihanPresenter = container.resolve(PelatihanPresenter);
      const getAllPelatihan = await pelatihanPresenter.getAllPelatihan(
        pagee,
        state.rows,
        keyword,
        tahun,
        jenis_pelatihan_id,
        '',
        null,
        status_publish
      );

      const data = getAllPelatihan;

      if (!data || data.length === 0) {
        setState((prevstate) => ({
          ...prevstate,
          pelatihan: [],
          jumlahPage: 0,
        }));
      } else {
        setJumlahPage(data[0].jumlahData / state.rows);
        setState((prevstate) => ({
          ...prevstate,
          pelatihan: data,
        }));
      }

      setLoading(false);
    } catch (error: any) {
      console.log('error pelatihan:', error);
      setLoading(false);
    }
  };

  const getPengajuanPelatihan = async (
    pagee: number,
    keyword: string,
    tahun: string,
    jenis_pelatihan_id: string
  ) => {
    setLoading(true);

    try {
      const pengajuanPelatihanPresenter = container.resolve(
        PengajuanPelatihanPresenter
      );
      const getAllPengajuanPelatihan =
        await pengajuanPelatihanPresenter.getAllPengajuanPelatihan(
          pagee,
          state.rows,
          keyword,
          tahun,
          jenis_pelatihan_id,
          ''
        );

      const data = getAllPengajuanPelatihan;

      if (!data || data.length === 0) {
        setState((prevstate) => ({
          ...prevstate,
          pengajuanPelatihan: [],
          jumlahPagePengajuan: 0,
        }));
      } else {
        setJumlahPagePengajuan(data[0].jumlahData / state.rows);
        setState((prevstate) => ({
          ...prevstate,
          pengajuanPelatihan: data,
        }));
      }

      setLoading(false);
    } catch (error: any) {
      setLoading(false);
    }
  };

  const searchDebounceRef = React.useRef<ReturnType<typeof setTimeout> | null>(null);
  
  const searchPelatihan = (value: string) => {
    setState((prevstate) => ({
      ...prevstate,
      keyword: value,
    }));
    if (searchDebounceRef.current) {
      clearTimeout(searchDebounceRef.current);
    }

    searchDebounceRef.current = setTimeout(() => {
      getPelatihan(1, value, state.tahun, state.jenis_pelatihan_id, state.status_publish);
    }, 500);
  };

  const searchPengajuanDebounceRef = React.useRef<ReturnType<typeof setTimeout> | null>(null);
  
  const searchPengajuanPelatihan = (value: string) => {
    setState((prevstate) => ({
      ...prevstate,
      keywordPengajuan: value,
    }));
    if (searchPengajuanDebounceRef.current) {
      clearTimeout(searchPengajuanDebounceRef.current);
    }

    searchPengajuanDebounceRef.current = setTimeout(() => {
      getPengajuanPelatihan(
        1,
        value,
        state.tahunPengajuan,
        state.jenis_pengajuan_pelatihan_id
      );
    }, 500);
  };

  const filterTahun = (value: string) => {
    setState((prevstate) => ({
      ...prevstate,
      pelatihan: [],
      jumlahPage: 0,
    }));
    setLoading(true);
    getPelatihan(1, state.keyword, value, state.jenis_pelatihan_id, state.status_publish);
    setState((prevstate) => ({
      ...prevstate,
      tahun: value,
      page: 1,
    }));
  };

  const filterTahunPengajuan = (value: string) => {
    setState((prevstate) => ({
      ...prevstate,
      pengajuanPelatihan: [],
      jumlahPagePengajuan: 0,
    }));
    setLoading(true);
    getPengajuanPelatihan(
      1,
      state.keywordPengajuan,
      value,
      state.jenis_pengajuan_pelatihan_id
    );
    setState((prevstate) => ({
      ...prevstate,
      tahunPengajuan: value,
      pagePengajuan: 1,
    }));
  };

  const filterJenisPelatihan = (value: string) => {
    setState((prevstate) => ({
      ...prevstate,
      pelatihan: [],
      jumlahPage: 0,
    }));
    setLoading(true);
    getPelatihan(1, state.keyword, state.tahun, value, state.status_publish);
    setState((prevstate) => ({
      ...prevstate,
      jenis_pelatihan_id: value,
      page: 1,
    }));
  };

  const filterStatusPublish = (value: string) => {
    setState((prevstate) => ({
      ...prevstate,
      pelatihan: [],
      jumlahPage: 0,
    }));
    setLoading(true);
    getPelatihan(1, state.keyword, state.tahun, state.jenis_pelatihan_id, value);
    setState((prevstate) => ({
      ...prevstate,
      status_publish: value,
      page: 1,
    }));
  };

  const filterJenisPengajuanPelatihan = (value: string) => {
    setState((prevstate) => ({
      ...prevstate,
      pengajuanPelatihan: [],
      jumlahPagePengajuan: 0,
    }));
    setLoading(true);
    getPengajuanPelatihan(
      1,
      state.keywordPengajuan,
      state.tahunPengajuan,
      value
    );
    setState((prevstate) => ({
      ...prevstate,
      jenis_pengajuan_pelatihan_id: value,
      pagePengajuan: 1,
    }));
  };

  const getSubMenuJenisPelatihan = async () => {
    try {
      const menuJenisPelatihanPresenter = container.resolve(
        MenuJenisPelatihanPresenter
      );

      const get = await menuJenisPelatihanPresenter.getAllSubMenuJenisPelatihan(
        1,
        10000000,
        ''
      );

      const data = get;

      setState((prevstate) => ({
        ...prevstate,
        subMenuJenisPelatihan: data,
      }));
    } catch (error: any) {
      console.log('error get Jenis Pelatihan:', error);
    }
  };

  return (
    <ManajemenPelatihanProvider
      value={{
        state,
        getPelatihan,
        getPengajuanPelatihan,
        setPage,
        setPagePengajuan,
        searchPelatihan,
        searchPengajuanPelatihan,
        filterTahun,
        filterTahunPengajuan,
        filterJenisPelatihan,
        filterJenisPengajuanPelatihan,
        filterStatusPublish,
        getSubMenuJenisPelatihan,
      }}
    >
      {children}
    </ManajemenPelatihanProvider>
  );
};

export const useManajemenPelatihanContext = () => React.useContext(Context);
// eslint-disable-next-line
export default {
  useManajemenPelatihanContext,
  Provider,
};
